import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from "app/pages/AgentPricing/actionTypes";
import { changeCurrentDialog } from "app/pages/AgentPricing/actions";
import { CurrentAgentCommissionDialog } from "app/pages/AgentPricing/modules/EditDialogs";
import { Button } from 'antd';
import { UsergroupAddOutlined } from '@ant-design/icons';

interface StateProps {}

interface DispatchProps {
    onAddRemoveSchools: () => void
}

type InternalProps = StateProps & DispatchProps

function EditRatesTableButtonPanel(props: InternalProps) {
    return (
        <div style={{ marginTop: 24, marginBottom: 24, textAlign: 'right' }}>
            <Button 
                type="primary" 
                onClick={props.onAddRemoveSchools}
                icon={<UsergroupAddOutlined />}
                size="large"
            >
                Add/Remove Schools
            </Button>
        </div>
    );
}

function mapStateToProps(state: any, ownProps: {}) : StateProps {
    return {

    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<any, any, Action>) : DispatchProps {
    return {
        onAddRemoveSchools: () => dispatch(changeCurrentDialog(CurrentAgentCommissionDialog.ChangeSchoolOverride))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditRatesTableButtonPanel);